var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.299,
    viewBox: "0 0 20 17.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "New_Customers",
    "data-name": "New Customers",
    d: "M.585,17.3a.592.592,0,0,1-.416-.171A.58.58,0,0,1,0,16.712a9.159,9.159,0,0,1,2.056-5.739A9.27,9.27,0,0,1,6.648,7.938a4.373,4.373,0,1,1,5.057,0,9.2,9.2,0,0,1,6.654,8.772.587.587,0,0,1-.587.586Zm9.233-6.639,1.051,3.386a.586.586,0,0,1-.076.5l-1.07,1.582h7.441a8.007,8.007,0,0,0-6.219-7.182Zm-8.626,5.47h7.44L7.562,14.547a.575.575,0,0,1-.072-.5l1.047-3.386L7.406,8.945A8,8,0,0,0,1.192,16.129Zm7.494-2.005.492.725.489-.725-.489-1.582Zm0-5.363.492.744.489-.742c-.176-.012-.343-.018-.512-.018C9,8.745,8.849,8.75,8.687,8.761ZM5.974,4.369a3.2,3.2,0,1,0,3.2-3.2A3.206,3.206,0,0,0,5.974,4.369Zm11.135.821V2.941H14.984V2.234h2.124V0h.758V2.234H20v.707H17.866V5.19Z",
    fill: "#bebfb6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomers);
export default __webpack_public_path__ + "static/media/NewCustomers.9e49882eedcae0d19c2ff89e4a92a75b.svg";
export { ForwardRef as ReactComponent };